import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';
import { flexibleBooleanFromString } from './common-utils.js';

/** ISO date strings or Temporal.Instant (e.g. serialized API payloads vs internal shapes). */
export const dateStringOrInstant = z.union([z.string(), z.instanceof(Temporal.Instant)]);

/**
 * Zod safeParse() error object to string
 * https://github.com/colinhacks/zod/issues/2883
 * @returns
 */
export function getZodErrorMessage(error: z.ZodError): string {
  const message = error.message;
  const parsedMessage = JSON.parse(message) as Array<{ message: string }>;
  const zodError = parsedMessage[0];
  if (!zodError) throw Error('Zod is broken');
  return zodError.message;
}

export const nonEmptyString = z.string({ message: 'Required' }).min(1, {
  message: 'Required',
});
export const booleanString = z.enum(['true', 'false'], { message: 'Required' });
export const intString = z.string({ message: 'Required' }).regex(/^\d+$/, {
  message: 'Please enter a valid number.',
});

export const optionalEmail = z
  .string()
  .transform((val) => (!val ? undefined : val))
  .pipe(z.string().email({ message: 'Invalid email format' }).optional())
  .optional();

/**
 * Flexible boolean schema that accepts various string formats for CSV parsing.
 * Accepts: null, empty string, TRUE, FALSE, False, True, true, false
 */
export const flexibleBoolean = z
  .string()
  .nullable()
  .transform((val) => flexibleBooleanFromString(val))
  .pipe(z.boolean().nullable());
